const benefits = [
  {
    icon: 'ri-search-eye-line',
    title: 'Product Discovery',
    description: 'Find trending products quickly with pre-verified links and curated collections from trusted sellers across Chinese marketplaces.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Price Research',
    description: 'Compare products across different sellers before purchasing, ensuring you get the best value for your money every time.',
  },
  {
    icon: 'ri-time-line',
    title: 'Shopping Efficiency',
    description: 'Save hours of manual searching through marketplaces by using organized spreadsheets with direct product links.',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description: 'Follow proven shopping workflows designed by experienced buyers, making international shopping accessible to everyone.',
  },
];

export default function BenefitsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            Why Choose Us
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Why Thousands of Buyers Use Sugargoo Spreadsheet
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Join a growing community of international shoppers who have transformed their buying experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-7 rounded-lg bg-background-100 border border-background-200 hover:border-primary-200 transition-all duration-200"
            >
              <span className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors duration-200">
                <i className={`${benefit.icon} text-lg md:text-xl text-primary-600`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-900 whitespace-nowrap">
                {benefit.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}